export default __webpack_public_path__ + "static/media/reperence1.3efdd8be.jpg";